module.exports = __webpack_public_path__ + "static/img/104138.834714a9.png";